import { ErrorResult } from '../../../../shared/models/types'
import { BadRequestResponse } from '../../../../types/Errors'
import { deleteAuthorisation } from '../api/http'

function useDeleteAuthorisations() {
  const deleteAuthorisations = async (ids: number[]) => {
    if (!ids.length) return { errors: [] }

    const deletePromises = ids.map((id) => deleteAuthorisation(id))
    const settledDeletePromises = await Promise.allSettled(deletePromises)

    const errors: ErrorResult[] = []
    const rejectedDocumentPromises = settledDeletePromises.filter((result): result is PromiseRejectedResult => result.status === 'rejected')
    rejectedDocumentPromises.forEach((result) => {
      const errorResponseData = result.reason?.response?.data
      if (errorResponseData?.message === 'CONSTRAINT_VIOLATION') {
        errorResponseData?.errors.forEach((errorItem: BadRequestResponse) => {
          errors.push({
            message: errorResponseData.message,
            field: errorItem.field,
            code: errorItem.reason,
          })
        })
      }
    })

    return {
      errors,
    }
  }

  return {
    deleteAuthorisations,
  }
}

export default useDeleteAuthorisations
